module.exports = __webpack_public_path__ + "static/img/bonus_6.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_6.png
// module id = cntA
// module chunks = 0